"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var React = _interopRequireWildcard(require("react"));

var _ActiveButton = _interopRequireDefault(require("./ActiveButton"));

var _PageButtonLink = _interopRequireDefault(require("./PageButtonLink"));

var Pages = function Pages(_ref) {
  var pageCount = _ref.pageCount,
      selectedPage = _ref.selectedPage,
      onPageChange = _ref.onPageChange,
      _ref$enlargement = _ref.enlargement,
      enlargement = _ref$enlargement === void 0 ? 1 : _ref$enlargement,
      size = _ref.size;
  return Array.apply(void 0, (0, _toConsumableArray2.default)(Array(pageCount))).map(function (_, index) {
    var key = index + enlargement;
    return selectedPage === key ? /*#__PURE__*/React.createElement(_ActiveButton.default, {
      key: key,
      size: size
    }, key) : /*#__PURE__*/React.createElement(_PageButtonLink.default, {
      key: key,
      onPageChange: onPageChange,
      size: size
    }, key);
  });
};

var _default = Pages;
exports.default = _default;